import { AppNS } from 'app';
import { ApiCollectionResponse, Params } from 'app/types';

import { request } from '../config';

const TICKETS_URL = 'tickets';

export function apiGetTickets(data: Params, signal?: AbortSignal): Promise<ApiCollectionResponse<AppNS.Ticket>> {
  return request(
    {
      url: `${TICKETS_URL}.json`,
      method: 'GET',
      params: { ...data },
      signal,
    },
    (data) => data.models
  );
}

export function apiGetTicketById(id: string, signal?: AbortSignal): Promise<AppNS.Ticket> {
  return request(
    {
      url: `${TICKETS_URL}/${id}.json`,
      method: 'GET',
      signal,
    },
    (data) => data.model
  );
}

export function apiUpdateTicket(id: string, data: Partial<AppNS.Ticket>): Promise<AppNS.Ticket> {
  return request(
    {
      url: `${TICKETS_URL}/${id}.json`,
      method: 'PATCH',
      data: { ticket: data },
    },
    (data) => data.model
  );
}

export function apiAddTicket(data: Partial<AppNS.Ticket>): Promise<AppNS.Ticket> {
  return request(
    {
      url: `${TICKETS_URL}.json`,
      method: 'POST',
      data: { ticket: data },
    },
    (data) => data.model
  );
}

export function apiGetAdmins(data: Params): Promise<AppNS.User[]> {
  return request(
    {
      url: `users.json`,
      method: 'GET',
      params: { ...data, role: 'admin', limit: 999 },
    },
    (data) => data.users.results
  );
}

export interface ApiTicketStateUpdate {
  id: string;
  doNotAllowModifications?: boolean;
  state?: AppNS.TicketState;
  comment?: string;
  dobNotes?: string;
}

export function apiUpdateTicketState(id: string, data: Partial<ApiTicketStateUpdate>): Promise<AppNS.Ticket> {
  return request(
    {
      url: `${TICKETS_URL}/${id}/update-state.json`,
      method: 'PATCH',
      data: { ticket: data },
    },
    (data) => data.model
  );
}
